module.exports = __webpack_public_path__ + "img/img32.c608b3d6.jpg";